/**
 * @fileoverview HTTP connection
 */
'use strict';
// Library Import
import axiosBase from 'axios';
import _ from 'lodash';
// Util Import
import * as ConstUtil from '../util/ConstUtil';
import * as LogUtil from '../util/LogUtil';
import AppConfig from '../AppConfig';

/**
 * HTTP
 *
 * @class HTTP
 */
class HTTP {
  constructor() {
    this.axios = null;
  }

  /**
   * インスタンス生成
   *
   * @param {String} baseUrl ベースURL
   * @param {Object} headers HTTPヘッダー
   * @param {Integer} timeout タイムアウト
   * @memberof HTTP
   */
  createInstance(baseUrl, headers, timeout) {
    this.axios = axiosBase.create({
      baseURL: baseUrl,
      headers: headers,
      timeout: timeout
    });
  }

  /**
   * HTTP通信
   *
   * @param {Object} api API情報
   * @param {Object} data リクエストデータ
   * @param {Function} callback 呼び出し元のコールバック処理
   * @returns
   * @memberof HTTP
   */
  connect(api, data, callback) {
    if (!this.axios) {
      LogUtil.d('ERROR!! You must call createInstance method.');
      return;
    }
    let connectionUrl = AppConfig.versionInformation.api + api.URI;
    if (_.isEmpty(api.URI)) {
      connectionUrl = api.URL;
    }

    LogUtil.d('(' + api.METHOD + ') ' + 'API:' + api.URI);
    // リクエストタイプ分岐
    switch (api.METHOD) {
      case ConstUtil.Common.REQUEST_TYPE_LIST.GET:
        this.get(connectionUrl, data, callback);
        break;
      case ConstUtil.Common.REQUEST_TYPE_LIST.POST:
        this.post(connectionUrl, data, callback);
        break;
      case ConstUtil.Common.REQUEST_TYPE_LIST.PUT:
        this.put(connectionUrl, data, callback);
        break;
      case ConstUtil.Common.REQUEST_TYPE_LIST.DELETE:
        this.delete(connectionUrl, data, callback);
        break;
      default:
        break;
    }
  }

  /**
   * REST-API の GET メソッドを実行する
   *
   * @param {String} url REST-API のURL
   * @param {Array} params パラメーターリスト
   * @param {Function} callback 呼び出し元のコールバック処理
   * @memberof HTTP
   */
  get(url, params, callback) {
    this.axios
      .get(url, params)
      .then(function(res) {
        // 正常時
        // LogUtil.d('Status Code:' + res.status);
        callback(null, res);
      })
      .catch(function(error) {
        // 異常時
        LogUtil.d('HTTP GET ERROR!! happend by Backend.');
        callback(error, null);
      });
  }

  /**
   * REST-API の POST メソッドを実行する
   *
   * @param {String} url REST-API のURL
   * @param {Object} data axios のオプションに指定するdata
   * @param {Function} callback 呼び出し元のコールバック処理
   * @memberof HTTP
   */
  post(url, data, callback) {
    if (!this.axios) {
      LogUtil.d('ERROR!! You must call createInstance method.');
      return;
    }

    this.axios
      .post(url, data)
      .then(function(res) {
        // 正常時
        // LogUtil.d('Status Code:' + res.status);
        callback(null, res);
      })
      .catch(function(error) {
        // 異常時
        LogUtil.d('HTTP POST ERROR!! happend by Backend.');
        callback(error, null);
      });
  }

  /**
   * REST-API の PUT メソッドを実行する
   *
   * @param {String} url REST-API のURL
   * @param {Object} data axios のオプションに指定するdata
   * @param {Function} callback 呼び出し元のコールバック処理
   * @memberof HTTP
   */
  put(url, data, callback) {
    this.axios
      .put(url, data)
      .then(function(res) {
        // 正常時
        // LogUtil.d('Status Code:' + res.status);
        callback(null, res);
      })
      .catch(function(error) {
        // 異常時
        LogUtil.d('HTTP PUT ERROR!! happend by Backend.');
        callback(error, null);
      });
  }

  /**
   * REST-API の DELETE メソッドを実行する
   *
   * @param {String} url REST-API のURL
   * @param {Object} data axios のオプションに指定するdata
   * @param {Function} callback 呼び出し元のコールバック処理
   * @memberof HTTP
   */
  delete(url, data, callback) {
    this.axios
      .delete(url, { data: data })
      .then(function(res) {
        // 正常時
        // LogUtil.d('Status Code:' + res.status);
        callback(null, res);
      })
      .catch(function(error) {
        // 異常時
        LogUtil.d('HTTP DELETE ERROR!! happend by Backend.');
        callback(error, null);
      });
  }
}
export default new HTTP();



// WEBPACK FOOTER //
// ./src/js/connection/HTTP.jsx